import { useGetEmployeeMeQuery } from "../api/employee";
import { RoleEnum } from "../enums/RoleEnum";

interface ReturnType {
    isEstablishmentManager: boolean;
    isGroupManager: boolean;
    isEmployee: boolean;
    isAspRole: boolean;
    shouldLeaveForAdminApp: boolean;
}

export const useRole = (): ReturnType => {
    const { data: me } = useGetEmployeeMeQuery({});

    const aspRoles = [
        RoleEnum.SUPER_ADMIN,
        RoleEnum.ASP_ADMIN,
        RoleEnum.LMS_ADMIN,
        RoleEnum.ADMINISTRATOR_DEVIATIONS,
    ];

    const isAspRole =
        me?.roles.some((role) => aspRoles.includes(role.role)) ?? false;

    const establishmentManagerRoleCount =
        me?.roles.filter((role) => role.role === RoleEnum.ESTABLISHMENT_MANAGER)
            .length ?? 0;

    const isEstablishmentManager = establishmentManagerRoleCount === 1;
    const isGroupManager = establishmentManagerRoleCount > 1;

    const isEmployee =
        me?.roles.some((role) => role.role === RoleEnum.EMPLOYEE) ?? false;

    const shouldLeaveForAdminApp =
        isAspRole && !isEmployee && !isEstablishmentManager && !isGroupManager;

    return {
        isEstablishmentManager,
        isGroupManager,
        isAspRole,
        isEmployee,
        shouldLeaveForAdminApp,
    };
};
